import { render, staticRenderFns } from "./xian-C-1.vue?vue&type=template&id=5f8fffba&scoped=true&"
import script from "./xian-C-1.vue?vue&type=script&lang=js&"
export * from "./xian-C-1.vue?vue&type=script&lang=js&"
import style0 from "./xian-C-1.vue?vue&type=style&index=0&id=5f8fffba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8fffba",
  null
  
)

component.options.__file = "xian-C-1.vue"
export default component.exports